import { useCallback, useRef } from 'react'
import { useConfirmChangeFromRecurrenceToRegularOrderModal } from '../components/modals/ConfirmChangeFromRecurrenceToRegularOrderModal'

export function useConfirmFromRecurrenceToSingleOrder() {
  const { show: showConfirmChangeModal, Modal } =
    useConfirmChangeFromRecurrenceToRegularOrderModal()

  const confirmFromRecurrenceToSingleOrderPromiseRef = useRef<{
    resolve: () => void
    reject: (reason?: any) => void
  }>()

  const confirmFromRecurrenceToSingleOrder = useCallback(async () => {
    return new Promise<void>((resolve, reject) => {
      confirmFromRecurrenceToSingleOrderPromiseRef.current = { resolve, reject }
      showConfirmChangeModal()
    })
  }, [showConfirmChangeModal])

  return {
    confirmFromRecurrenceToSingleOrder,
    confirmFromRecurrenceToSingleOrderPromiseRef,
    Modal,
  }
}
